import { $currentOperator } from '@/stores';
import { openDialog } from '@/stores/dialog';
import { $cheatSheet } from '@/stores/floating';
import { useStore } from '@nanostores/react';

export default function BottomMenu() {
  const operator = useStore($currentOperator);

  return (
    <div
      className="z-10 w-full bg-white px-4 py-2 print:hidden"
      style={{
        boxShadow: 'rgba(0, 0, 0, 0.6) 0px 10px 10px 7px',
      }}
      id="operator-header"
    >
      <label className="mb-1 block text-xs font-semibold">
        Operator / Opérateur
      </label>
      <div className="flex flex-row gap-2">
        <button
          onClick={() => openDialog('changeOperator')}
          className="flex items-center gap-2 rounded border border-gray-600 bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 shadow-md hover:bg-gray-300 focus:ring-2 focus:ring-gray-400 focus:outline-none"
          id="change-operator-button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="h-5 w-5 fill-current"
          >
            <path d="M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z" />
          </svg>
          {operator ? operator.name : 'Select Operator'}
        </button>
        <button
          onClick={() => openDialog('codewords')}
          className="flex items-center gap-2 rounded border border-gray-600 bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 shadow-md hover:bg-gray-300 focus:ring-2 focus:ring-gray-400 focus:outline-none"
          id="change-operator-button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="h-5 w-5 fill-current"
          >
            <path d="M7 14C5.9 14 5 13.1 5 12S5.9 10 7 10 9 10.9 9 12 8.1 14 7 14M12.6 10C11.8 7.7 9.6 6 7 6C3.7 6 1 8.7 1 12S3.7 18 7 18C9.6 18 11.8 16.3 12.6 14H16V18H20V14H23V10H12.6Z" />
          </svg>
          Codewords
        </button>
        <button
          onClick={() => openDialog('scheduledReminders')}
          className="flex items-center gap-2 rounded border border-gray-600 bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 shadow-md hover:bg-gray-300 focus:ring-2 focus:ring-gray-400 focus:outline-none"
          id="change-operator-button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="h-5 w-5 fill-current"
          >
            <path d="M12,20A7,7 0 0,1 5,13A7,7 0 0,1 12,6A7,7 0 0,1 19,13A7,7 0 0,1 12,20M12,4A9,9 0 0,0 3,13A9,9 0 0,0 12,22A9,9 0 0,0 21,13A9,9 0 0,0 12,4M12.5,8H11V14L15.75,16.85L16.5,15.62L12.5,13.25V8M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72Z" />
          </svg>
          Reminders
        </button>
        <button
          onClick={() => $cheatSheet.set(!$cheatSheet.get())}
          className="flex items-center gap-2 rounded border border-gray-600 bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 shadow-md hover:bg-gray-300 focus:ring-2 focus:ring-gray-400 focus:outline-none"
          id="change-operator-button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="h-5 w-5 fill-current"
          >
            <path d="M20 5L20 19L4 19L4 5H20M20 3H4C2.89 3 2 3.89 2 5V19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V5C22 3.89 21.11 3 20 3M18 15H6V17H18V15M10 7H6V13H10V7M12 9H18V7H12V9M18 11H12V13H18V11Z" />
          </svg>
          Cheat sheet
        </button>
      </div>
    </div>
  );
}
